import { ExActionTree } from "vuex";
import { State, Actions, Getters, Mutations } from "./types";
import * as api from "@/api";
import { removeToken, saveToken } from "@/helpers/auth-helper";

const actions: ExActionTree<State, Actions, Getters, Mutations> = {
  async signIn(ctx, payload) {
    try {
      const response = await api.signIn(payload);
      saveToken({
        partnerUser: response.data.partner_user
      });
      ctx.commit("signInSuccess", {
        partnerUser: response.data.partner_user
      });
    } catch (error) {
      throw error;
    }
  },
  async signInToken(ctx, payload) {
    try {
      const response = await api.signInToken(payload);
      saveToken({
        partnerUser: response.data.partner_user
      });
      ctx.commit("signInSuccess", {
        partnerUser: response.data.partner_user
      });
    } catch (error) {
      throw error;
    }
  },
  async signOut(ctx) {
    try {
      await api.signOut();
      removeToken();
      ctx.commit("updateUser", {
        partnerUser: undefined
      });
    } catch (e) {
      throw e;
    }
  },
  async getPartnerUser(ctx) {
    try {
      const response = await api.getPartnerUser();
      if (ctx.state.partnerUser) {
        ctx.commit("updateUser", {
          partnerUser: {
            ...ctx.state.partnerUser,
            ...response.data,
            partner: response.data.partner || ctx.state.partnerUser.partner
          }
        });
      }
    } catch (e) {
      throw e;
    }
  },
  async getContracts(ctx) {
    try {
      const response = await api.getContracts();
      ctx.commit("updateContracts", {
        availableContracts: response.data.available_contracts,
        expiredContracts: response.data.expired_contracts
      });
    } catch (error) {
      throw error;
    }
  },
  async passwordReissue(_ctx, payload) {
    try {
      await api.passwordReissue(payload);
    } catch (error) {
      throw error;
    }
  },
  async passwordReset(ctx, payload) {
    try {
      const response = await api.passwordReset(payload);
      saveToken({
        partnerUser: response.data.partner_user
      });
      ctx.commit("signInSuccess", {
        partnerUser: response.data.partner_user
      });
    } catch (error) {
      throw error;
    }
  },
  async scoutPlan(ctx, payload) {
    try {
      ctx.commit("scoutPlan", {
        scoutPlan: payload.scoutPlan,
        remainingTicketsCount: payload.remainingTicketsCount,
        expirationAtMs: payload.expirationAtMs,
        scoutTargetGraduateYears: payload.scoutTargetGraduateYears
      });
    } catch (error) {
      throw error;
    }
  },
  async savedSearchOptionCount(ctx, payload) {
    try {
      ctx.commit("savedSearchOptionCount", payload);
    } catch (error) {
      throw error;
    }
  },
  async changeMenuType(ctx, payload) {
    try {
      ctx.commit("changeMenuType", payload);
    } catch (error) {
      throw error;
    }
  }
};
export default actions;
